(function($) {

   var calendarWrapper = $('.event-calendar .events-wrapper');
   var calendarWrapperSecondary = calendarWrapper.find('.events-wrapper-secondary');
   var calendarNavigation = $('.event-calendar .calendar-navigation li');
   var calendarEvents = calendarWrapper.find('.calendar-listing');
   var resultNotice = calendarWrapper.find('.no-results-notice');

   // Scroll then navigation to current month on mobile

   $(window).on('load', function() {
      // scroll the mobile navigation
      if (window.matchMedia("(max-width: 930px)").matches) {
         $('.calendar-navigation').each(function (ind, el) {
            $(el).find('ul').animate({
               scrollLeft: '+=' + $(el).find('li.active').offset().left
            }, 300, 'swing');
         })
      }
   });

   calendarNavigation.on('click', function() {

      // Don't run if the clicked filter is active
      if ($(this).hasClass('active')) {
         return false;
      }

      var month = $(this).data('month');
      var filteredEvents = calendarEvents.filter('[data-month="'+month+'"]');

       // Toggling navigation elements
      $(this).siblings().removeClass('active');
      $(this).addClass('active');

      // Filtering the events in the calendar
      calendarWrapper.css({'transition': '0.5s ease-in-out'});
      calendarWrapper.addClass('hidden');

      setTimeout(function() {
         calendarWrapper.css({'height': calendarWrapperSecondary.outerHeight(), 'transition': 'none'});
         calendarEvents.addClass('hidden');

         if (filteredEvents.length) {
            resultNotice.removeClass('active');
            filteredEvents.removeClass('hidden');
         } else {
            resultNotice.addClass('active');
         }

         if (calendarWrapper.outerHeight() !== calendarWrapperSecondary.outerHeight()) {
            calendarWrapper.animate({'height': calendarWrapperSecondary.outerHeight()}, 300, function() {
               setTimeout(function() {
                  calendarWrapper.css({'transition': '0.5s ease-in-out', 'height': 'auto'});
                  calendarWrapper.removeClass('hidden');
               }, 250);
            });
         } else {
            setTimeout(function() {
               calendarWrapper.css({'transition': '0.5s ease-in-out', 'height': 'auto'});
               calendarWrapper.removeClass('hidden');
            }, 250);
         }

      }, 500);
   });

})( jQuery );